var map = {
	"./building_bank.png": 656,
	"./building_blue_moon_inn.png": 864,
	"./building_cow_pen.png": 505,
	"./building_falador_inn.png": 141,
	"./building_falador_pub.png": 957,
	"./building_varrock.png": 464,
	"./building_wheat_field.png": 604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;